

export default function mapNewRoleNames(role) {
	switch (role){
		case 'admin': 
			return 'admin'
		case 'shipper':
			return 'user'
		case 'user':
			return 'user'
		case 'reader':
			return 'readOnly'
		default:
			return 'readOnly'
	}
}
